// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1pCIQ","cell":"ColumnAccessor_cell__26wNl","firstCellAccent":"ColumnAccessor_firstCellAccent__1T1J9"};